import React from 'react';
import PropTypes from 'prop-types';

import mime from 'mime-types'

class InputFileReader extends React.Component {
    constructor(...args) {
        super(...args)

        this.state = { hasError: false, isDragging: false }
    }

    setIsDragging = (toggle = false) => {
        this.setState({ isDragging: toggle })
    }

    setHasError = (toggle = false) => {
        this.setState({ hasError: toggle })
    }

    suppress(event) {
        event.stopPropagation()
        event.preventDefault()
    }

    handleDragOverEnter = event => {
        this.suppress(event)
        this.setIsDragging(true)
    }

    handleDragLeaveEnd = event => {
        this.suppress(event)
        this.setHasError(false)
        this.setIsDragging(false)
    }

    handleDrop = event => {
        this.handleDragLeaveEnd(event)

        const files = event.dataTransfer.files

        if (files && files[0]) {
            this.handleFileLoad(files[0])
        }
    }

    handleChange = event => {
        const files = event.target.files
        if (files && files[0]) {
            this.handleFileLoad(files[0])
        }
        // We need to do this so the user can choose the same file
        // over and over if they really want to
        event.target.value = ""
    }

    handleFileLoad = file => {
        this.setHasError(false)

        if (!this.validateMimeType(file)) {
            this.setHasError(true)
            return false
        }

        if (window.FileReader) {
            const reader = new FileReader()
            const hasReadAsBinaryString = !!reader.readAsBinaryString;

            reader.onload = (event) => this.props.onFileLoad(event.target.result)

            reader[hasReadAsBinaryString ? 'readAsBinaryString' : 'readAsArrayBuffer'](file)
        } else {
            console.error('Sorry, your browser does\'nt support file uploads')
        }
    }

    validateMimeType = file => this.props.accept.map(value => mime.lookup(value)).includes(file.type)

    render() {
        const { accept, capture, multiple, children } = this.props
        const { hasError, isDragging } = this.state

        const fileInputId = 'input-file-reader-file'
        const fileInputStyle = { width: '0.1px', height: '0.1px', opacity: 0, overflow: 'hidden', position: 'absolute', zIndex: -1 }

        const childrenWithProps = React.Children.map(children, child => (
            React.cloneElement(child, { accept, hasError, isDragging, fileInputId }))
        )

        return (
            <div
                className="input-file-reader-box"
                onDrag={this.suppress}
                onDragStart={this.suppress}
                onDragOver={this.handleDragOverEnter}
                onDragEnter={this.handleDragOverEnter}
                onDragLeave={this.handleDragLeaveEnd}
                onDragEnd={this.handleDragLeaveEnd}
                onDrop={this.handleDrop}
            >
                <input
                    type="file"
                    id={fileInputId}
                    accept={Array.isArray(accept) ? accept.join(',') : accept}
                    multiple={multiple}
                    capture={capture}
                    onChange={this.handleChange}
                    style={fileInputStyle}
                />
                {childrenWithProps}
            </div>
        )
    }
}

InputFileReader.defaultProps = {
    accept: ['.csv', '.xls', '.xlsx', '.txt'],
    capture: false,
    multiple: false,
}

InputFileReader.propTypes = {
    accept: PropTypes.arrayOf(PropTypes.string),
    capture: PropTypes.bool,
    multiple: PropTypes.bool,
    onFileLoad: PropTypes.func.isRequired,
}

export default InputFileReader
